// disable console log errors
import './lib/console.js';

// include needed polyfills
// import fetch from 'whatwg-fetch';
require('es6-promise').polyfill();

// feature detection
require('./.generated/modernizr.js');

// picture element shim
require('script!picturefill');

// polyfill for browsers which don't support xlink:href
require('script!svgxuse');

// optimized font loading
import fontFaceLoader from '@spinnwerk/font-face-loader';
fontFaceLoader({
    fonts: [
        'Aptifer Sans',
        'Aptifer Slab',
        'Rosalinda'
    ]
});



// WEBPACK FOOTER //
// ./resources/assets/js/critical.js